import React, { PureComponent } from "react";
import NoData from "../NoData/NoData";
import * as d3 from "d3";
import MomentsOvertimeChart from "./MomentsOvertimeChart";
import moment from "moment-timezone";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import html2canvas from "html2canvas";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import IntervalSelector from "../IntervalSelector";
class MomentsOvertime extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.chartEl = React.createRef();
        this.chartComponent = React.createRef();
    }

    componentDidMount() {
        // this.drawChart();
    }

    getSum(total, num) {
        return total + num;
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        !this.props.drilldown_charts &&
            contextMenu
                .append("li")
                .text("View Insights")
                .on("click", () => {
                    // console.log('drilldown')
                    self.handleDrilldownClick(chart);
                    // this.props.showChartsDrilldown(true, "momentovertime");
                });
        contextMenu.style("display", "block");
    };

    createNewFilter = (d) => {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        newFilter.tag_category_ids = d.series.userOptions.momentId ? "" + d.series.userOptions.momentId : d.series.userOptions.momentIds.join(",");
        let lastComparisonIndex = false;
        lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("55");
        newFilter = getViewConversationDuration(
            d,
            newFilter,
            this.props.aggs_val,
            this.props.filters,
            this.props.comparisionData,
            lastComparisonIndex,
            this.props.comparisonAppliedFilter,
        );

        //  newFilter = getViewConversationDuration(d, newFilter, this.props.aggs_val, this.props.filters);
        return newFilter;
    };

    handleContextMenuClick = (d) => {
        let newFilter = this.createNewFilter(d);
        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    formatData(data) {
        let res = {};
        let columns = [];
        let xsArray = ["x"];
        columns.push(xsArray.concat(data.xs));
        let sumsArray = [];
        for (let key in data) {
            if (key !== "xs") {
                let currentObj = {};
                currentObj.key = key;
                currentObj.sum = data[key].reduce(this.getSum);
                currentObj.data = data[key];
                sumsArray.push(currentObj);
            }
        }
        for (var i = 0; i < 10 && i < sumsArray.length; i++) {
            let temp = [sumsArray[i].key];
            columns.push(temp.concat(sumsArray[i].data));
        }
        res.columns = columns;

        return res;
    }

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let data = this.formatData(this.props.data.responseObj);
        let comparisonCSVData = this.props.comparisionData && this.formatData(this.props.comparisionData.responseObj);

        let formatString = "YYYY-MM-DD HH:mm";
        let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
        data.columns[0] = data.columns[0].map((d) => (d === "x" ? "x" : moment(d).tz(userTz).format(formatString)));

        if (this.props.comparisionData) {
            // [comparisonCSVData[comparisonCSVData.length - 1], comparisonCSVData[0]] = [comparisonCSVData[0], comparisonCSVData[comparisonCSVData.length - 1]];
            comparisonCSVData.columns[0] = comparisonCSVData.columns[0].map((d) => (d === "x" ? "Comparison Time" : moment(d).tz(userTz).format(formatString)));

            // comparisonCSVData.columns.map((ele, ind) => {
            //     ele[0] =  ele[0];
            // });
        }

        let csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));
        csvFmt[0][0] = "Time";

        if (this.props.comparisionData) {
            let comparisoncsvFmt = comparisonCSVData.columns[0].map((col, i) => comparisonCSVData.columns.map((row) => row[i]));

            csvFmt.push(...comparisoncsvFmt);
        }

        let firstIndLen = csvFmt[0].length;
        let lastIndLen = csvFmt[csvFmt.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < csvFmt.length; j++) {
                if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                else arr[i].push(0);
            }
        }

        downloadCSVData(arr, this.props.widget.name);
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="Shows the volume of conversation from news sources overtime." />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}

                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {(this.props.isPublic && nodata) || this.props.drilldown_charts ? null : (
                            <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />}
                        <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                        {/* {!nodata && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )} */}

                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate moment-overtime" ref={this.chartEl}>
                        <MomentsOvertimeChart
                            data={this.props.data.chartData}
                            addContextMenuListener={this.addContextMenuListener}
                            // resizedCount={this.props.resizedCount}
                            showLegend={this.props.showLegend}
                            showGridLines={this.props.showGridLines}
                            widgetContainerRef={this.props.widgetContainerRef}
                            comparisionData={this.props.comparisionData}
                            legendClick={this.props.legendClick}
                            expandWidget={this.props.expandWidget}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        filterOptions: state.globalReducer.filterOptions,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MomentsOvertime);
